import _ from 'lodash';
import {DEFAULT_STATE_VALUE} from './constants';

// this file exports two functions, which are the 'bridge' between the URL and app state:

// mapLocationToState takes location object and app state,
//   and returns new app state with location params merged into it

// mapStateToLocation takes app state and location,
//   and returns new location updated from app state

// functions necessary for parsing the URL parameters (eg. dates, numbers) can be implemented in here,
// or if more complicated, can be specified more rigidly somewhere else and called here



export function mapLocationToState(state, location) {
 // console.log('history URL>State',state,location)  
//  var state2={};
  switch(location.pathname) {
    
    case "/":
      const stateFromLocation = location.query;
    
     // state.initial_load=true
     state.loading = 'new'
  //   console.log('DECODE START',stateFromLocation)
     
    if (stateFromLocation !== undefined && stateFromLocation['clist'] !=='-1') {
      stateFromLocation['clist'] = decodeURIComponent(stateFromLocation['clist'])
     }
//console.log('DECODE end',stateFromLocation)
//if (stateFromLocation !== undefined )
state['session'] = 'none'
state['s'] = '7651'
     

     //console.log('DECODE START',stateFromLocation)
     if (stateFromLocation !== undefined) {
      for (let i = 1;i<9;i++) {
        if (stateFromLocation['e'+i.toString()] !=='') {
          stateFromLocation['e'+i.toString()] = decodeURIComponent(stateFromLocation['e'+i.toString()])
         }
       }
     } 
     //console.log('DECODE START 2',stateFromLocation)
     //console.log('load from url',state, stateFromLocation)
      return _.merge({}, state, stateFromLocation);

    default:
      //console.log('default history')
      return state;
  }
}


// this is just a rough sketch of possible transformers.
// real ones could be much bigger or smarter,
// and could use schemas or constants files more effectively,
// but the point is having one location where this happens

export const paramSetup = {
  global: {
    test: {stateKey: 'test',  options: {shouldPush: true},initialState: ''},
    s: {stateKey: 's',  options: {shouldPush: true},initialState: '7651'}, //DEFAULT_STATE_VALUE},
    action: {stateKey: 'action',  options: {shouldPush: true},initialState: 'redirect'},
    c: {stateKey: 'c',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    session: {stateKey: 'session',  options: {shouldPush: true},initialState: 'no_session'},
    zsku: {stateKey: 'zsku',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    cfg: {stateKey: 'cfg',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    d: {stateKey: 'd',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    i: {stateKey: 'i',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    sc: {stateKey: 'sc',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s1: {stateKey: 's1',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s2: {stateKey: 's2',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s3: {stateKey: 's3',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s4: {stateKey: 's4',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s5: {stateKey: 's5',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s6: {stateKey: 's6',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s7: {stateKey: 's7',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s8: {stateKey: 's8',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s9: {stateKey: 's9',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    s10: {stateKey: 's10',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a1: {stateKey: 'a1',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a2: {stateKey: 'a2',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a3: {stateKey: 'a3',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a4: {stateKey: 'a4',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a5: {stateKey: 'a5',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a6: {stateKey: 'a6',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a7: {stateKey: 'a7',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a8: {stateKey: 'a8',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a9: {stateKey: 'a9',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    a10: {stateKey: 'a10',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    m:  {stateKey: 'm',  options: {shouldPush: true},initialState:  DEFAULT_STATE_VALUE},
    f:  {stateKey: 'f',  options: {shouldPush: true},initialState:  '0'},
    rs: {stateKey: 'rs',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    bl: {stateKey: 'bl',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    cl: {stateKey: 'cl',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    e1: {stateKey: 'e1',  options: {shouldPush: true},initialState: ''},
    e2: {stateKey: 'e2',  options: {shouldPush: true},initialState: ''},
    e3: {stateKey: 'e3',  options: {shouldPush: true},initialState: ''},
    e4: {stateKey: 'e4',  options: {shouldPush: true},initialState: ''},
    e5: {stateKey: 'e5',  options: {shouldPush: true},initialState: ''},
    e6: {stateKey: 'e6',  options: {shouldPush: true},initialState: ''},
    e7: {stateKey: 'e7',  options: {shouldPush: true},initialState: ''},
    e8: {stateKey: 'e8',  options: {shouldPush: true},initialState: ''},
    clist: {stateKey: 'clist',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    acat: {stateKey: 'acat',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    acharm: {stateKey: 'acharm',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    ai: {stateKey: 'ai',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    am: {stateKey: 'am',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    locket: {stateKey: 'locket',  options: {shouldPush: true},initialState: '-1'},
    chain: {stateKey: 'chain',  options: {shouldPush: true},initialState: '-1'},
    realinit: {stateKey: 'realinit',  options: {shouldPush: true},initialState: '-1'},
    env: {stateKey: 'env',  options: {shouldPush: true},initialState: 'staging'}
  
          
  }
};


// WEBPACK FOOTER //
// ./src/location.js